/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Определяет поведение зависимости квеста от родительского.
 * @export
 * @enum {string}
 */
export var FxIdDomainCrossPlayQuestDependencyType;
(function (FxIdDomainCrossPlayQuestDependencyType) {
    FxIdDomainCrossPlayQuestDependencyType[FxIdDomainCrossPlayQuestDependencyType["HardLock"] = 0] = "HardLock";
    FxIdDomainCrossPlayQuestDependencyType[FxIdDomainCrossPlayQuestDependencyType["ChainedProgress"] = 1] = "ChainedProgress";
    FxIdDomainCrossPlayQuestDependencyType[FxIdDomainCrossPlayQuestDependencyType["NUMBER_unknown_default_open_api"] = 11184809] = "NUMBER_unknown_default_open_api";
})(FxIdDomainCrossPlayQuestDependencyType || (FxIdDomainCrossPlayQuestDependencyType = {}));
export function instanceOfFxIdDomainCrossPlayQuestDependencyType(value) {
    for (const key in FxIdDomainCrossPlayQuestDependencyType) {
        if (Object.prototype.hasOwnProperty.call(FxIdDomainCrossPlayQuestDependencyType, key)) {
            if (FxIdDomainCrossPlayQuestDependencyType[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function FxIdDomainCrossPlayQuestDependencyTypeFromJSON(json) {
    return FxIdDomainCrossPlayQuestDependencyTypeFromJSONTyped(json, false);
}
export function FxIdDomainCrossPlayQuestDependencyTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function FxIdDomainCrossPlayQuestDependencyTypeToJSON(value) {
    return value;
}
export function FxIdDomainCrossPlayQuestDependencyTypeToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=FxIdDomainCrossPlayQuestDependencyType.js.map